import { display_help_modal } from '@frontend/help';
import { Button, Tooltip, TooltipPlacement } from '@phi/components';
import { set } from '@phi/util/vuetils';
import { PropType, defineComponent, h, ref } from 'vue';

export const HelpTooltip = defineComponent({
    props: {
        placement: {
            required: false,
            type: null as any as PropType<TooltipPlacement>,
        },

        timeout: {
            required: false,
            type: Number,
            default: 500,
        },

        help: {
            required: false,
            type: String,
        },
    },

    setup(props, { slots }) {
        const shown = ref(false);
        return () => h(Tooltip, {
            placement: props.placement,
            timeout: props.timeout,
            shown: shown.value,
            'onUpdate:shown': set(shown),
        }, {
            default: slots.default,
            tooltip: () => [
                slots.tooltip && slots.tooltip(),
                props.help && h(Button, {
                    variant: 'primary',
                    onClick: () => {
                        shown.value = false;
                        display_help_modal(props.help!);
                    },
                }, () => 'Read more...')
            ]
        });
    }
});
